/**
 * Add here all error related enums
 */

export enum ErrorType {
	EMAIL = 'email',
	REQUIRED = 'required',
	PHONE = 'phone',
	PHONE_REQUIRED = 'phoneRequired',
	PHONE_REGISTERED = 'phoneRegistered',
}

export enum ErrorMessage {
	DEFAULT = 'Invalid input. Please try again.',
	EMAIL = 'Please enter a valid email address.',
	REQUIRED = 'This field is required.',
	PHONE = 'n552',
	PHONE_REQUIRED = 'n551',
	PHONE_REGISTERED = 'n554',
}
